module.exports = __webpack_public_path__ + "static/media/1O2A0802 (2).e5f00af0.jpg";